import { useEffect, useRef } from 'react';
import type { ReservationPermissions } from './use-reservation-permissions';
import type { ReservationsSearch, ReservationsSearchChange } from '../lib/reservations-list-search';

/**
 * Sales role default scope: without reservation.force_release the list starts
 * narrowed to the caller's own holdings. Waits for the permissions to resolve
 * (fail-closed `canForceRelease` is false while loading) so a manager on a slow
 * load is never auto-filtered for good (CU-86cb4wjwm). Fires once per mount.
 */
export function useSalesDefaultScope(
  search: ReservationsSearch,
  userId: number | undefined,
  permissions: ReservationPermissions,
  onSearchChange: ReservationsSearchChange,
): void {
  const applied = useRef(false);
  const needsSalesFilter =
    !permissions.isLoading &&
    !permissions.canForceRelease &&
    search.holderUserId.length === 0 &&
    userId !== undefined;

  useEffect(() => {
    if (applied.current) return;
    if (needsSalesFilter && userId !== undefined) {
      applied.current = true;
      onSearchChange({ holderUserId: [String(userId)] }, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally fires only once per mount (guarded by ref)
  }, [needsSalesFilter, userId]);
}
